import { render, staticRenderFns } from "./modal-trunks-create-edit-form.vue?vue&type=template&id=7f48ac3e&"
import script from "./modal-trunks-create-edit-form.vue?vue&type=script&lang=js&"
export * from "./modal-trunks-create-edit-form.vue?vue&type=script&lang=js&"
import style0 from "./modal-trunks-create-edit-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports